<div>
  <div class="text-center p-5" *ngIf="!isLoaded">
    <i class="fa fa-spin fa-spinner fa-2x"></i>
  </div>

  <div *ngIf="isLoaded">
    <div class="ui-g">
      <div class="ui-g-12 align-items-center flex justify-content-between">
        <div class="">
          <div class="flex align-items-center chip gap-2" *ngIf="inspectionJobs.length > 0">
            <i
              [ngClass]="getDeploymentStatusIcon().icon"
              [style.color]="getDeploymentStatusIcon().color"
              class="status-icon"
            ></i>
            <span [pTooltip]="'Deployment Status'">{{
              getDeploymentStatusDescription(deploymentStatus)
            }}</span>
          </div>
        </div>
        <button
          *ngIf="isLoaded"
          pButton
          type="button"
          label="Deploy Jobs"
          class="ui-button ui-button-primary ui-button-success btn-to-right pull-right"
          (click)="confirm()"
          [disabled]="isDeployJobsButtonDisabled"
        ></button>
      </div>
    </div>

    <p-table
      [value]="inspectionJobs"
      [paginator]="false"
      selectionMode="single"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="jobNumber" style="width: 150px">Job Number</th>
          <th pSortableColumn="reg">Vehicle Reg</th>
          <th pSortableColumn="supplierName">Supplier Name</th>
          <th pSortableColumn="siteCode" style="width: 150px">Site Code</th>
          <th pSortableColumn="jobCreatedDate">Job Created Date</th>
          <th pSortableColumn="status" style="width: 150px">Status</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <a (click)="viewJob(item.jobId, $event)">{{ item.jobNumber }}</a>
          </td>
          <td>
            <div class="flex justify-content-center">
              <vehicle-reg>{{ item.reg }}</vehicle-reg>
            </div>
          </td>
          <td>{{ item.supplierName }}</td>
          <td>{{ item.siteCode }}</td>
          <td>{{ item.jobCreatedDate | datex : 'ddd DD MMM YYYY' }}</td>
          <td style="min-width: 150px; text-align: center">
            <div class="status-container">
              <i
                [ngClass]="getRowStatusIcon(item.deploymentStatus).icon"
                [style.color]="getRowStatusIcon(item.deploymentStatus).color"
                class="status-icon"
              ></i>
              <span class="mt-1">{{ getRowStatusDescription(item.deploymentStatus) }}</span
              ><span *ngIf="item.errorMessage">{{ item.errorMessage }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="6">There are no inspection jobs awaiting deployment.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Confirm"
  rejectLabel="Cancel"
></p-confirmDialog>
